<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <a id="sample-sub-header-back-domestic" class="l-top-navi__back-link" (click)="clickBack($event)">
            <span class="u-visually-hidden" [innerHTML]="'reader.goBackToPreviousPage' | staticMsg"></span>
          </a>
        </div>
        <div class="l-top-navi__heading-area">
          <h1 class="l-top-navi__heading-text" [innerHTML]="'label.searchResult.title' | staticMsg"></h1>
        </div>
        <!-- [ヘッダー下メニュー ボタンエリア] -->
        <div class="l-top-navi__function-area">
          <!-- <div class="l-top-navi__function-item">
            <button id="sample-sub-header-1" class="l-top-navi__function-btn l-top-navi__function-btn--history">
              <span class="u-visually-hidden">History</span>
            </button>
          </div>
          <div class="l-top-navi__function-item">
            <button id="sample-sub-header-2" class="l-top-navi__function-btn l-top-navi__function-btn--favorites">
              <span class="u-visually-hidden">Favorites</span>
            </button>
          </div> -->
          <div class="l-top-navi__function-item">
            <button
              id="sample-sub-header-domestic"
              class="l-top-navi__function-btn l-top-navi__function-btn--modify"
              (click)="openReSearchModal()"
            >
              <span class="l-top-navi__function-btn-text" [innerHTML]="'label.searchChange' | staticMsg"></span>
            </button>
          </div>
        </div>
        <!-- //[ヘッダー下メニュー ボタンエリア] -->

        <!-- [ステップナビゲーション] -->
        <div class="l-top-navi__progress-area">
          <ol class="l-top-navi__progress-list">
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active l-top-navi__progress-item--current">
              <div class="l-top-navi__progress-wrap">
                <span class="u-visually-hidden" [innerHTML]="'reader.breadcrumb.current' | staticMsg"></span>
                <span
                  aria-hidden="true"
                  class="l-top-navi__progress-num"
                  [innerHTML]="'label.breadcrumb.first' | staticMsg"
                ></span>
                <span
                  aria-hidden="true"
                  class="l-top-navi__progress-text"
                  [innerHTML]="'label.flightSearch' | staticMsg"
                ></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span
                  aria-hidden="true"
                  class="l-top-navi__progress-num"
                  [innerHTML]="'label.breadcrumb.second' | staticMsg"
                ></span>
                <span
                  aria-hidden="true"
                  class="l-top-navi__progress-text"
                  [innerHTML]="'label.passengerInformationInput' | staticMsg"
                ></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span
                  aria-hidden="true"
                  class="l-top-navi__progress-num"
                  [innerHTML]="'label.breadcrumb.third' | staticMsg"
                ></span>
                <span
                  aria-hidden="true"
                  class="l-top-navi__progress-text"
                  [innerHTML]="'label.suchAsSeatAssign' | staticMsg"
                ></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span
                  aria-hidden="true"
                  class="l-top-navi__progress-num"
                  [innerHTML]="'label.breadcrumb.fourth' | staticMsg"
                ></span>
                <span
                  aria-hidden="true"
                  class="l-top-navi__progress-text"
                  [innerHTML]="'label.purchase2' | staticMsg"
                ></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span
                  aria-hidden="true"
                  class="l-top-navi__progress-num"
                  [innerHTML]="'label.breadcrumb.fifth' | staticMsg"
                ></span>
                <span
                  aria-hidden="true"
                  class="l-top-navi__progress-text"
                  [innerHTML]="'label.complete' | staticMsg"
                ></span>
              </div>
            </li>
          </ol>
        </div>
        <!-- //[ステップナビゲーション] -->

        <!--
        /=====================================================
        アクセシビリティ対応（読み上げ対策）のため、
        SP/TABの際は[ヘッダー下メニュー ボタンエリア] 、[ステップナビゲーション]の順でhtmlを出力してください
        PCの際は[ステップナビゲーション]、[ヘッダー下メニュー ボタンエリア]の順でhtmlを出力してください
        =====================================================/
        -->
      </div>
    </div>
  </div>
</div>
